import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import SEO from "./components/SEO";
import CookieConsent from "./components/CookieConsent";
import Header from "./components/Header";
import HeroSlider, { MobileUSPBar } from "./components/HeroSlider";
import Services from "./components/Services";
import About from "./components/About";
import Team from "./components/Team";
import Process from "./components/Process";
import GoogleReviews from "./components/GoogleReviews";
import References from "./components/References";
import CTABlock from "./components/CTABlock";
import SocialMedia from "./components/SocialMedia";
import Contact from "./components/Contact";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import Impressum from "./components/Impressum";
import Datenschutz from "./components/Datenschutz";
import ReferenzenPage from "./components/ReferenzenPage";
import KarrierePage from "./components/KarrierePage";
import KontaktPage from "./components/KontaktPage";
import DienstleistungenPage from "./components/DienstleistungenPage";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEO page="home" />
      <Header />
      <main>
        <HeroSlider />
        <MobileUSPBar />
        <Services />
        <About />
        <Team />
        <Process />
        <GoogleReviews />
        <References />
        <CTABlock />
        <SocialMedia />
        <Contact />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App" data-testid="app-container">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/referenzen" element={<Navigate to="/referenzen/wuppertal" replace />} />
            <Route path="/referenzen/:locationId" element={<ReferenzenPage />} />
            <Route path="/karriere" element={<KarrierePage />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutzerklarung" element={<Datenschutz />} />
            <Route path="/kontakt" element={<KontaktPage />} />
            <Route path="/dienstleistungen" element={<DienstleistungenPage />} />
          </Routes>
        </BrowserRouter>
        <CookieConsent />
      </div>
    </HelmetProvider>
  );
}

export default App;
